import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { ConfirmDialog } from '@klareospace/pharos-lib-web-utils';

import { useArchiveHandlingUnitType } from '../hooks';

interface ArchiveHandlingUnitTypeDialogProps {
  handlingUnitTypeId: string;
  onClose: () => void;
}

export function ArchiveHandlingUnitTypeDialog({
  handlingUnitTypeId,
  onClose,
}: ArchiveHandlingUnitTypeDialogProps): React.JSX.Element {
  const { t } = useTranslation('settings');
  const archiveHandlingUnitType = useArchiveHandlingUnitType();

  function handleConfirm(): void {
    if (archiveHandlingUnitType.isPending) return;
    archiveHandlingUnitType.mutate(handlingUnitTypeId, { onSettled: () => onClose() });
  }

  function handleOpenChange(open: boolean): void {
    if (!open) onClose();
  }

  return (
    <ConfirmDialog
      cancelLabel={t('handlingUnitTypes.actions.archive.dialog.cancel')}
      confirmLabel={t('handlingUnitTypes.actions.archive.dialog.confirm')}
      description={t('handlingUnitTypes.actions.archive.dialog.description')}
      destructive
      isPending={archiveHandlingUnitType.isPending}
      onConfirm={handleConfirm}
      onOpenChange={handleOpenChange}
      open={!!handlingUnitTypeId}
      title={t('handlingUnitTypes.actions.archive.dialog.title')}
    />
  );
}
